module.exports = __webpack_public_path__ + "static/img/qiye.5aaec052.png";